import { Alert, Button, Col, Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, Row, Label, FormFeedback, Form, Input, FormGroup, Spinner } from 'reactstrap'
import Select from 'react-select'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { selectThemeColors } from '../../../utility/Utils'
import { Trash } from 'react-feather'
import { selectProfile, setLoader, setProfileLoader, updateBankDetails } from './store'
import React, { useEffect, useState } from 'react'
import { handleDecimal } from '../../components/modal/modalSubComponet'

 const BankDetails = ({toggle}) => {
  const { myProfile, loader,profileLoader } = useSelector((store) => store?.MyProfile)

    const dispatch = useDispatch()
    const {
      reset,
      control,
      setError,
      setValue,
      register,
      handleSubmit,
      formState: { errors }
    } = useForm({})
    const [file, setFile] = useState()
    // // //console.log('errors', errors)
    const [leveCount, setLeveCount] = useState(0)
    
    const [fileDeleted, setFileDeleted] = useState(false)
    const [active, setActive] = useState(true)
    const [paymentMode, setPaymentMode] = useState(1)
    const setMyActiveMode = (data) => {
      setActive(!active)
    }
  
    const genderOption = [{label:'Male',value:'male'},{label:'Female',value:'female'}]
  
    const handleDiscard = () => {
      dispatch(selectProfile(null))
      reset()
      toggle()
    }

  
    const onSubmit = async (data) => {
     // //console.log('data', data)
     let formData = new FormData()
     if(myProfile !== null){
          formData.append('bank_name', data.bank_name)
          formData.append('bank_accountno', data.bank_accountno)
          formData.append('bank_ifsc_code', data.bank_ifsc_code)
          formData.append('cheque_image', data.cheque_image)
          formData.append('upi_id', data.upi_id)
          formData.append('payment_mode', paymentMode)
     }
    dispatch(setLoader(true));

     const response = await dispatch(
        updateBankDetails( formData )
    )
    if (response) {
      handleDiscard()
  }
    }
  
    useEffect(() => {
    dispatch(setLoader(false));
    console.log('Modal', myProfile)

      if (myProfile) {    
        setValue('bank_name', myProfile.bank_name)
        setValue('bank_accountno', myProfile.bank_accountno)
        setValue('bank_ifsc_code', myProfile.bank_ifsc_code)
        setValue('cheque_image', myProfile.cheque_image)
        setValue('upi_id', myProfile.upi_id)
        setPaymentMode(Number(myProfile.payment_mode))
      }
    }, [myProfile])
  
    //Handle the uploaded file
    const handleFile = (e) => {
      // setIsFileUpdated(true)
      setValue('cheque_image', e.target.files[0])
      setFile(e.target?.files[0])
    }
    return (
      <Form onSubmit={handleSubmit((data) => onSubmit(data, 'Add'))}>
        <Row >
          <Col sm="6" className="mb-1" display="flex">
              <label htmlFor="payment_mode" className="form-label" value={paymentMode}>
                Select Bank/UPI
              </label>
              <select name="payment_mode" className='form-control' onChange={(e) => setPaymentMode(Number(e.target.value))}>
                <option value="1" selected={paymentMode===1 ? true : false} >Bank</option>
                <option value="2" selected={paymentMode===2 ? true : false} >UPI</option>
              </select>
          </Col>
          {paymentMode == 1 ?
          <>
          <Col sm="6" className="mb-1" display="flex">
            <Label className="form-label" for="bank_name">
            Bank Name
            </Label>
            <Controller
              name="bank_name"
              control={control}
              {...register('bank_name', {
                required: 'Please Enter Bank Name'
              })}
              render={({ field }) => (
                <Input
                  placeholder="Enter Bank Name"
                  id="bank_name"
                  invalid={errors.bank_name && true}
                  {...field}
                />
              )}
            />
            {errors && errors.bank_name && (
              <FormFeedback>{errors.bank_name.message}</FormFeedback>
            )}



          </Col>
          <Col sm="6" className="mb-1" display="flex">
            <Label className="form-label" for="bank_accountno">
            Account No.
            </Label>
            <Controller
              name="bank_accountno"
              control={control}
              {...register('bank_accountno', {
                required: 'Please Enter bank_accountno'
              })}
              render={({ field }) => (
                <Input
                type='number'
                placeholder="bank_accountno"
                  id="bank_accountno"
                  invalid={errors.bank_accountno && true}
                  {...field}
                onKeyPress={(e)=>handleDecimal(e,'number')}
                />
              )}
            />
            {errors && errors.bank_accountno && (
              <FormFeedback>{errors.bank_accountno.message}</FormFeedback>
            )}
          </Col>
          <Col sm="6" className="mb-1" display="flex">
            <Label className="form-label" for="bank_ifsc_code">
            IFSC Code
            </Label>
            <Controller
              name="bank_ifsc_code"
              control={control}
              {...register('bank_ifsc_code', {
                required: 'Please Enter bank_ifsc_code'
              })}
              render={({ field }) => (
                <Input
                placeholder="bank_ifsc_code"
                  id="bank_ifsc_code"
                  invalid={errors.bank_ifsc_code && true}
                  {...field}
                />
              )}
            />
            {errors && errors.bank_ifsc_code && (
              <FormFeedback>{errors.bank_ifsc_code.message}</FormFeedback>
            )}
          </Col>
          </>
          :
          <Col sm="6" className="mb-1" display="flex">
            <Label className="form-label" for="upi_id">
              UPI ID
            </Label>
            <Controller
              name="upi_id"
              control={control}
              {...register('upi_id', {
                required: 'Please Enter upi id'
              })}
              render={({ field }) => (
                <Input
                  placeholder="Enter upi_id"
                  id="upi_id"
                  invalid={errors.upi_id && true}
                  {...field}
                />
              )}
            />
            {errors && errors.upi_id && (
              <FormFeedback>{errors.upi_id.message}</FormFeedback>
            )}



          </Col>
        }

          {/* <Col sm={6} className="mb-1">
          <Label className="form-label" for="cheque_image">
            Upload Candled Cheque
          </Label>
          <Controller
            id="cheque_image"
            name="cheque_image"
            control={control}
            // {...register('cheque_image', {
            //     required: 'Please Upload Candled Cheque'
            //   })}
            render={({ field }) => (
              <Input
                id="cheque_image"
                type="file"
                name="cheque_image"
                invalid={errors.cheque_image && true}
                onChange={handleFile}
                files={file}
              />
            )}
          />
        </Col> */}
  
          <Col xs={12} className="text-center buttonWrapper mt-2">
          <Button className="me-1" color="primary" type="submit" disabled={loader}
          >
            {loader ? (
              <Spinner text="Loading..." color="white" size="sm" />
            ) : (
              'Add'
            )}
          </Button>
            <Button outline type="reset" onClick={handleDiscard}>
              Discard
            </Button>
          </Col>
        </Row>
      </Form>
    )
  }
  export default BankDetails